import React, { Component } from 'react';

import { navigate } from '@reach/router';

import { IAuthStore } from '../../../store/auth/store';

import { InnerRouter } from '../../../components/AnimatedRouter';
import ProgressBar from '../../../components/ProgressBar';
import { redWaglLogo } from '../../../assets/images/';
import { withContext } from '../../../contrib/utils';

enum STEP {
  'account',
  'info',
  'season',
  'complete'
}

interface IProps {
  auth: IAuthStore;
  children: React.ReactChild;
  location: any;
}

class ClubWizardComponent extends Component<IProps, {}> {
  constructor(props: IProps) {
    super(props);
  }

  public componentWillMount(): void {
    const { auth } = this.props;
    if (auth.isAuthenticated && location.pathname === `/staff/club/create/account`) {
      setTimeout(navigate.bind(this, `/staff/club/create/info`));
    }
  }

  public render(): JSX.Element {
    const { location } = this.props;
    const route: any =
      location.pathname.split('/')[5] === 'season' || location.pathname.split('/')[5] === 'complete'
        ? location.pathname.split('/')[5]
        : location.pathname.split('/')[4];

    return (
      <div className="admin-layout club-wizard">
        <div className="wrapper header-wrapper">
          <div className="logo-wrapper ">
            <img src={redWaglLogo} className="logo" alt="logo" />
          </div>
          <div>
            <hr className="shadow" />
          </div>
          <div className="progress-bar-wrapper">
            <ProgressBar step={Number(STEP[route]) || 0} />
          </div>
        </div>
        <div className="wrapper content">
          <InnerRouter className="slow" location={location}>
            {this.props.children}
          </InnerRouter>
        </div>
      </div>
    );
  }
}

const ClubWizard = withContext(ClubWizardComponent, 'auth', 'user');

export { ClubWizard, ClubWizardComponent };
